<template>
  <div id="upload-product-update-template" class="upload-file-section">
    <v-card
      max-width="600"
      outlined
      tile
    >
      <v-card-title class="text-h5">
        Upload product update template file
      </v-card-title>

      <v-card-text class="pb-3">
          <v-row no-gutters>
            <v-col
              cols="12"
            >
                <p>
                  Accepted extension: csv
                </p>
                <p>
                  Where to find in EPOS: <a href=" https://www.eposnowhq.com/Pages/BackOffice/SelfBatchImport.aspx">Appstore > My Apps > Bulk Import ('Set Up' button) > 'Download Product Update Template' button</a>
                </p>
            </v-col>
          </v-row>
          <v-row v-if="(files1.length !== 0) && !!files1[0]" no-gutters>
            <v-col
              cols="12"
            >
                <ul>
                  <li>
                    <span>{{files1[0].name}}</span><!--  -
                    <span>{{files1[0].size}}</span> -->
                    <span v-if="files1[0].error">
                      - error: {{files1[0].error}}
                    </span>
                    <span v-else-if="files1[0].success"> - success</span>
                    <span v-else-if="files1[0].active"> - active</span>
                    <span v-else></span>
                  </li>
                </ul>
            </v-col>
          </v-row>
      </v-card-text>

      <v-card-actions>
        <div class="upload-bookkeeping-file-btns upload-btns-group">
          <v-btn color="amber darken-4" text outlined rounded
          >
            <file-upload
              input-id="product-update-template-file"
              class="btn btn-primary"
              :post-action="uploadProductUpdateTemplateUrl"
              :headers="{'Authorization': sessionAuthToken}"
              extensions="csv"
              :multiple="false"
              @input-file="inputUpdateProductUpdateTemplate"
              v-model="files1"
              ref="uploadProductUpdateTemplate">
              <i class="fa fa-plus"></i>
              <span>&nbsp; Select file</span>
            </file-upload>
          </v-btn>
          <v-btn  
            class="mx-5"
            color="cyan darken-2" 
            text outlined rounded
            v-if="!$refs.uploadProductUpdateTemplate || !$refs.uploadProductUpdateTemplate.active"
            @click="$refs.uploadProductUpdateTemplate.active = true"
          >
            <i class="fa fa-arrow-up" aria-hidden="true"></i>
            <span>&nbsp;Start Upload</span>
          </v-btn>
          <v-btn
            class="mx-5"
            color="red darken-2" 
            text outlined rounded
            v-else
            @click.prevent="$refs.uploadProductUpdateTemplate.active = false"
          >
            <i class="fa fa-stop" aria-hidden="true"></i>
            <span>&nbsp;Stop Upload</span>
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import FileUpload from 'vue-upload-component';

import session from '../api/session';


export default {
  data() {
    return {
      sessionAuthToken: session.defaults.headers.Authorization,
      files1: [],
      uploadProductUpdateTemplateUrl: `${process.env.API_BASE_URL || ''}/api/uploads/product_update_template`,
    };
  },
  components: {
    FileUpload,
  },
  computed: {
    ...mapState('mainTable', [
      'productUpdateTemplateFile',
    ]),
  },
  methods: {
    inputUpdateProductUpdateTemplate(file) {
      this.$store.dispatch('mainTable/uploadProductUpdateTemplate', file);
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/UploadProductUpdateTemplate.vue